import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

Vue.http.options.root = process.env.API_URL

Vue.http.interceptors.push(function(request, next) {
  var token = localStorage.getItem('token')
  if (token) {
    request.headers.set('Authorization', 'Bearer ' + token)
  }

  next(function(response) {
    if (response.status === 401) {
      localStorage.removeItem('token')
      Vue.router.push('/login')
    }
  })
})

export default Vue.http



// WEBPACK FOOTER //
// ./src/http.js